import ElectronicBillReport from "./ElectronicBillReport";

export default ElectronicBillReport;
